import PageSEO from '@/shared/PageSEO/PageSEO';
import SubscriptionsForFamily from '../../src/components/pages/Subscriptions/SubscriptionsForFamily';

export default function FamilySubscriptions() {
  return (
    <>
      <PageSEO
        title="Family Subscription Types | Rockalingua"
        description="Have your children learn SPanish in a fun and effective way."
        includeSchemaMarkup
      />
      <SubscriptionsForFamily />
    </>
  );
}
